module.exports = __webpack_public_path__ + "img/kormanyvaltasig_nem_szulok_11.03b05af7.jpg";